import { useTranslation } from 'react-i18next';
import styles from './FinishQuestionnarie.module.scss';

const FinishQuestionnarie = () => {
  const { t } = useTranslation();
  return (
    <span className={styles.finishQuestionnarie}>
      {t('questionnaire_completion_thanks')}
    </span>
  );
};

export default FinishQuestionnarie;
